exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Text */\n.uu5-forms-text-area {\n  margin-top: 0.1em;\n  margin-bottom: 1em;\n}\n.uu5-forms-text-area:after {\n  display: block;\n  position: relative;\n  content: '';\n  clear: both;\n}\n.uu5-forms-text-area .uu5-forms-message {\n  margin-top: -4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/text-area.less
// module id = 332
// module chunks = 0